import React, { useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useLocation, Link } from 'react-router-dom';
import { RootState } from 'modules';
import { useRecoilState } from 'recoil';
import {
  getMenuTitle,
  mentoringMenuTitle,
  companyMenuTitle,
  introductionMenuTitle,
  CSLabMenuTitle,
  caseMenuTitle,
  communityMenuTitle,
} from 'components/base/HeaderLeft';
import SNSLinkedIconGroup from 'components/base/SNSLinkedIconGroup';
import PrivacyModal from 'components/modal/PrivacyModal';
import TermsAndConditionsModal from 'components/modal/TermsAndConditionsModal';
import { QNABtnUserListState } from 'modules/mentoring/recoilState';
import {
  CWindowWidth,
  CRegistrationNumber,
  CBusinessNumber,
  CChiefExecutive,
  CAddress,
  CEmail,
  CBigstepIntroduction,
  CBigstepMentoringGuide,
  CRefundInformation,
  CBusinessName,
  CAdminCall,
  CYoutubeURL,
  CKakaoTalkURL,
  CInstagramURL,
  CNotionFAQURL,
} from 'constants/base.const';
import { EUserType } from 'enums/base.enum';
import { EMentoringField } from 'enums/mentoring.enum';
import { ERoute } from 'enums/route.enum';
import { Col, Row, Typography, Avatar } from 'antd';
import styled from 'styled-components';
import { PrimaryColor, device } from 'GlobalStyles';
import InstagramSource from 'assets/icons/instagram.svg';
import KakaoSource from 'assets/icons/kakao-talk.svg';
import LogoSource from 'assets/images/logos/logo.svg';
import YoutubeSource from 'assets/images/logos/youtube.webp';

const FooterWrapper = styled.div`
  background-color: transparent;
  border-top: 1px solid #f0f8f6;
  width: 100%;
  color: ${PrimaryColor};
  padding: 10px 50px;
  .small-logo {
    opacity: 0.3;
    .ant-avatar-square {
      width: 16px;
      height: 16px;
    }
  }
  .company-information {
    text-align: center;
    font-size: 11px;
  }
  .terms {
    text-align: right;
  }
  @media screen and ${device.md} {
    padding: 5px;
    .company-information,
    .terms {
      text-align: left;
    }
  }
  @media screen and ${device.lg} {
    padding: 5px;
    .company-information,
    .terms {
      text-align: left;
    }
  }
  font-size: 12px;
  a {
    color: ${PrimaryColor};
  }
  p {
    margin-bottom: 6px;
  }
`;
const { Text } = Typography;
export const FooterArea = () => {
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  const [privacyModal, setPrivacyModal] = useState(false);
  const [termsAndConditionsModal, setTermsAndConditionsModal] = useState(false);
  const [QNABtnUserList, setQNABtnUserList] = useRecoilState<any>(QNABtnUserListState);

  return (
    <>
      <FooterWrapper>
        {currentUser ? (
          <>
            <Row
              gutter={[4, 8]}
              style={{
                maxWidth: `${CWindowWidth}px`,
                marginTop: 10,
                marginBottom: 20,
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            >
              <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                <Link to={'/'}>
                  <img alt='CAREER STEP' src={LogoSource} style={{ width: 'auto', height: '18px' }} />
                </Link>
                <div style={{ marginTop: '3px', fontSize: '10px' }}>
                  <Text>Copyright &#169; 2021 (주)빅스텝에듀케이션, 모든권리 보유.</Text>
                </div>
                <div style={{ marginTop: '10px' }}>
                  <SNSLinkedIconGroup />
                </div>
              </Col>

              {currentUser.is_verified === true && (
                <Col xs={7} sm={7} md={2} lg={2} xl={2}>
                  <p>
                    <strong>{caseMenuTitle(currentUser)}</strong>
                  </p>

                  {/* 프레임워크 */}
                  <p>
                    <Link to={ERoute.CSLearningBoard}>{getMenuTitle(ERoute.CSLearningBoard)[1]}</Link>
                  </p>
                  {/* 스터디 문제 */}
                  {currentUser.primary_field !== EMentoringField.Finance && (
                    <p>
                      <Link to={ERoute.CSLearningQuizList}>{getMenuTitle(ERoute.CSLearningQuizList)[1]}</Link>
                    </p>
                  )}
                  {/* 케이스 노트 소개 */}
                  {currentUser.primary_field !== EMentoringField.Finance && (
                    <p>
                      <Link to={ERoute.CaseIntroduction}>{getMenuTitle(ERoute.CaseIntroduction)[1]}</Link>
                    </p>
                  )}
                  {/* 시즌별 original case */}
                  {/* <p>
                      <Link to={ERoute.CaseBoard}>
                        {getMenuTitle(ERoute.CaseBoard)[1]}
                      </Link>
                    </p> */}
                  {/* 케이스 library */}
                  {/* <p>
                    <Link to={ERoute.CaseLibrary}>
                      {getMenuTitle(ERoute.CaseLibrary)[1]}
                    </Link>
                  </p> */}
                </Col>
              )}
              {currentUser.is_verified === true && (
                <Col xs={7} sm={7} md={2} lg={2} xl={2}>
                  <p>
                    <strong>{mentoringMenuTitle(currentUser)}</strong>
                  </p>
                  <p>
                    <Link to={ERoute.MentoringMentorList}>{getMenuTitle(ERoute.MentoringMentorList)[1]}</Link>
                  </p>
                  <p>
                    <Link to={ERoute.MentoringMyPage}>{getMenuTitle(ERoute.MentoringMyPage)[1]}</Link>
                  </p>
                  {currentUser?.user_type === EUserType.Mentee &&
                    currentUser.primary_field !== EMentoringField.Finance && (
                      <p>
                        <Link to={ERoute.MentoringDashboard}>
                          {getMenuTitle(ERoute.MentoringDashboard)[1]}
                        </Link>
                      </p>
                    )}
                  {currentUser?.user_type === EUserType.Mentor && (
                    <p>
                      <Link to={ERoute.MentoringMyMentee}>{getMenuTitle(ERoute.MentoringMyMentee)[1]}</Link>
                    </p>
                  )}
                  <p>
                    <Link to={ERoute.MentoringAbout}>{getMenuTitle(ERoute.MentoringAbout)[1]}</Link>
                  </p>
                  {currentUser?.user_type === EUserType.Mentee && (
                    <p>
                      <Link to={ERoute.MentoringProgramAbout}>
                        {getMenuTitle(ERoute.MentoringProgramAbout)[1]}
                      </Link>
                    </p>
                  )}
                  {currentUser?.user_type === EUserType.Mentor && (
                    <p>
                      <Link to={ERoute.MentoringMentorList}>
                        {getMenuTitle(ERoute.MentoringMentorList)[1]}
                      </Link>
                    </p>
                  )}
                  {currentUser?.user_type === EUserType.Mentor && (
                    <p>
                    <strong>
                      <a target='_blank' href={CBigstepMentoringGuide}>
                        멘토링 수업 가이드
                      </a>
                    </strong>
                  </p>
                  )}
                  {/* Q&A */}
                  {/* 정규반 리스트만 Q&A 게시판 확인 가능하도록 */}
                  {/* {QNABtnUserList?.includes(currentUser?.userid) && (
                    <p>
                      <Link to={ERoute.MentoringQNA}>{getMenuTitle(ERoute.MentoringQNA)[1]}</Link>
                    </p>
                  )} */}
                </Col>
              )}
              {currentUser.is_verified === true && (
                <Col xs={7} sm={7} md={2} lg={2} xl={2}>
                  <p>
                    <strong>{communityMenuTitle()}</strong>
                  </p>

                  {/* 인터뷰 후기 */}
                  <p>
                    <Link to={ERoute.InterviewReviewBoard}>
                      {getMenuTitle(ERoute.InterviewReviewBoard)[1]}
                    </Link>
                  </p>
                  {/* 최종합격 후기 */}
                  {currentUser.primary_field !== EMentoringField.Finance && (
                    <p>
                      <Link to={ERoute.FinalAcceptanceBoard}>
                        {getMenuTitle(ERoute.FinalAcceptanceBoard)[1]}
                      </Link>
                    </p>
                  )}
                  {/* 모든 유저 Q&A 게시판 확인 가능하도록 */}
                  <p>
                    <Link to={ERoute.MentoringQNA}>{getMenuTitle(ERoute.MentoringQNA)[1]}</Link>
                  </p>
                </Col>
              )}

              {currentUser.primary_field !== EMentoringField.Finance && currentUser.is_verified === true && (
                <Col xs={7} sm={7} md={2} lg={2} xl={2}>
                  <p>
                    <strong>{companyMenuTitle(currentUser)}</strong>
                  </p>
                  { /*currentUser?.user_type === EUserType.Mentor && (
                    // 경력직 공고
                    <p>
                      <Link to={ERoute.CompanyTurnOver}>{getMenuTitle(ERoute.CompanyTurnOver)[1]}</Link>
                    </p>
                  ) */}
                  {/* 정규직 공고 */}
                  <p>
                    <Link to={ERoute.CompanyFulltime}>{getMenuTitle(ERoute.CompanyFulltime)[1]}</Link>
                  </p>
                  {/* 인턴공고 */}
                  { /*<p>
                    <Link to={ERoute.CompanyParttime}>{getMenuTitle(ERoute.CompanyParttime)[1]}</Link>
                  </p> */}
                  {currentUser?.user_type === EUserType.Mentor && currentUser?.userid === 'admin@admin.com' && (
                    // 채용공고 등록
                    <p>
                      <Link to={ERoute.CompanyJobOpening}>{getMenuTitle(ERoute.CompanyJobOpening)[1]}</Link>
                    </p>
                  )}
                </Col>
              )}
              {/* <Col xs={7} sm={7} md={2} lg={2} xl={2}>
                <p>
                  <strong>{introductionMenuTitle(currentUser)}</strong>
                </p>
                <p>
                  <Link to={ERoute.IntroductionCustomerInquiry}>
                    {getMenuTitle(ERoute.IntroductionCustomerInquiry)[1]}
                  </Link>
                </p>
                <p>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={CRefundInformation}
                  >
                    환불규정
                  </a>
                </p>
              </Col> */}
              {currentUser.primary_field !== EMentoringField.Finance && (
                <Col xs={7} sm={7} md={2} lg={2} xl={2}>
                  <p>
                    <strong>{CSLabMenuTitle()}</strong>
                  </p>
                  {/* 엑셀 강의 */}
                  <p>
                    <Link to={ERoute.ExcelClassList}>{getMenuTitle(ERoute.ExcelClassList)[1]}</Link>
                  </p>
                  {/* cs 뉴스 */}
                  <p>
                    <Link to={ERoute.CSLabBoard}>{getMenuTitle(ERoute.CSLabBoard)[1]}</Link>
                  </p>
                  {/* cs 웨비나 */}
                  <p>
                    <Link to={ERoute.CSWebinar}>{getMenuTitle(ERoute.CSWebinar)[1]}</Link>
                  </p>
                  {/* {currentUser?.user_type === EUserType.Mentor &&
                  currentUser.is_verified === true && (
                    //경력직 공고
                    <p>
                      <Link to={ERoute.CompanyTurnOver}>
                        {getMenuTitle(ERoute.CompanyTurnOver)[1]}
                      </Link>
                    </p>
                  )} */}
                  {/* 회사 탐색 */}
                  <p>
                    <Link to={ERoute.CompanySearch}>{getMenuTitle(ERoute.CompanySearch)[1]}</Link>
                  </p>
                  {/* 멘토파인더 */}
                  {/* <p>
                  <Link to={ERoute.CSLabMentorFinder}>
                    {getMenuTitle(ERoute.CSLabMentorFinder)[1]}
                  </Link>
                </p> */}
                  {/* {currentUser?.user_type === EUserType.Mentee && (
                  <p>
                    <Link to={ERoute.CSLabSwitchToMentor}>
                      {getMenuTitle(ERoute.CSLabSwitchToMentor)[1]}
                    </Link>
                  </p>
                )} */}
                  {currentUser?.user_type === EUserType.Mentor && currentUser.is_verified === true && (
                    <p>
                      <Link to={ERoute.CompanyInternFinder}>
                        {getMenuTitle(ERoute.CompanyInternFinder)[1]}
                      </Link>
                    </p>
                  )}
                </Col>
              )}
              <Col xs={7} sm={7} md={2} lg={2} xl={2}>
                {/* <p>
                  <strong>{introductionMenuTitle()}</strong>
                </p> */}
                {/* <p>
                  <Link to={ERoute.IntroductionCustomerInquiry}>
                    {getMenuTitle(ERoute.IntroductionCustomerInquiry)[1]}
                  </Link>
                </p> */}
                <p>
                  <a target='_blank' rel='noopener noreferrer' href={CNotionFAQURL}>
                    FAQ
                  </a>
                </p>
              </Col>
              <Col xs={7} sm={7} md={2} lg={2} xl={2}>
                <p>
                  <strong>
                    <Link to={ERoute.UserEdit}>{getMenuTitle('/user')[0]}</Link>
                  </strong>
                </p>
                <p>
                  <Link to={ERoute.UserEdit}>{getMenuTitle(ERoute.UserEdit)[1]}</Link>
                </p>
                {currentUser?.user_type === EUserType.Mentor && currentUser.is_verified === true && (
                  <p>
                    <Link to={ERoute.UserCreditExchange}>{getMenuTitle(ERoute.UserCreditExchange)[1]}</Link>
                  </p>
                )}
                {currentUser?.user_type === EUserType.Mentee && (
                  <p>
                    <Link to={ERoute.UserCredit}>{getMenuTitle(ERoute.UserCredit)[1]}</Link>
                  </p>
                )}
              </Col>
              <Col xs={7} sm={7} md={2} lg={2} xl={2}>
                <p>
                  <strong>
                    <a target='_blank' href={CBigstepIntroduction}>
                      회사
                    </a>
                  </strong>
                </p>
                <p>
                  <a target='_blank' href={CBigstepIntroduction}>
                    회사 소개
                  </a>
                </p>
              </Col>
            </Row>
            <Row gutter={[4, 8]} style={{ maxWidth: `${CWindowWidth}px`, margin: '0px auto' }}>
              <Col xs={24} sm={24} md={15} lg={15} xl={15}>
                <Text>
                  <strong>사업자등록번호</strong> {CRegistrationNumber} {CBusinessName}{' '}
                  <br className='hide-on-desktop' />
                  <strong>통신판매업신고번호</strong> {CBusinessNumber}
                  <br />
                  <strong>대표이사</strong> {CChiefExecutive} <br className='hide-on-desktop' />
                  <strong>주소</strong> {CAddress} <br className='hide-on-desktop' />
                  <strong>대표연락처</strong> {CEmail} <br className='hide-on-desktop' />
                  <p>
                    상품에 대하여 민원, 환불 등은 "(주)빅스텝에듀케이션"에서 처리하며 모든책임은
                    "(주)빅스텝에듀케이션"에 있습니다. 민원담당자 : 문희성 (010-6274-0989)
                  </p>
                </Text>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} className='terms'>
                <span
                  style={{ marginRight: '10px', cursor: 'pointer' }}
                  onClick={() => {
                    setPrivacyModal(true);
                  }}
                >
                  개인정보 처리방침
                </span>
                <span
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    setTermsAndConditionsModal(true);
                  }}
                >
                  이용약관
                </span>
                {currentUser?.user_type === EUserType.Mentee && (<a target='_blank' rel='noopener noreferrer' href={CRefundInformation}>
                &nbsp;&nbsp;&nbsp;환불규정
                </a>)}
              </Col>
            </Row>
          </>
        ) : (
          <Row gutter={[4, 8]} style={{ maxWidth: `${CWindowWidth}px`, margin: '0px auto' }} align='middle'>
            <Col xs={24} sm={24} md={6} lg={6} xl={6}>
              <img alt='CAREER STEP' src={LogoSource} style={{ width: 'auto', height: '18px' }} />
              <div style={{ marginTop: '3px', fontSize: '10px' }}>
                <Text>Copyright &#169; 2021 (주)빅스텝에듀케이션, 모든권리 보유.</Text>
              </div>
              <div style={{ marginTop: '10px' }} className='small-logo'>
                <a href='https://www.instagram.com/bigstepedu' target='_blank' rel='noopener noreferrer'>
                  <Avatar style={{ marginRight: '15px' }} shape='square' src={InstagramSource} />
                </a>
                <a href='http://pf.kakao.com/_QxaJxdK' target='_blank' rel='noopener noreferrer'>
                  <Avatar style={{ marginRight: '15px' }} shape='square' src={KakaoSource} />
                </a>
                <a
                  href='https://www.youtube.com/channel/UCgkAO-a21gnukng0vTZefhw'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <img style={{ width: '20px' }} alt='youtube' src={YoutubeSource} />
                </a>
              </div>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12} className='company-information'>
              <Text>
                <strong>사업자등록번호</strong> {CRegistrationNumber} {CBusinessName}{' '}
                <br className='hide-on-desktop' />
                <strong>통신판매업신고번호</strong> {CBusinessNumber}
                <br />
                <strong>대표이사</strong> {CChiefExecutive} <br className='hide-on-desktop' />
                <strong>주소</strong> {CAddress} <br className='hide-on-desktop' />
                <strong>대표연락처</strong> {CEmail} <br className='hide-on-desktop' />
                <p>
                  상품에 대하여 민원, 환불 등은 "(주)빅스텝에듀케이션"에서 처리하며 모든책임은
                  "(주)빅스텝에듀케이션"에 있습니다. 민원담당자 : 문희성 (010-6274-0989)
                </p>
              </Text>
            </Col>
            <Col xs={24} sm={24} md={6} lg={6} xl={6} className='terms'>
              <a
                style={{ marginRight: '10px' }}
                target='_blank'
                rel='noopener noreferrer'
                href={CBigstepIntroduction}
              >
                회사 소개
              </a>
              <span
                style={{ marginRight: '10px', cursor: 'pointer' }}
                onClick={() => {
                  setPrivacyModal(true);
                }}
              >
                개인정보 처리방침
              </span>
              <span
                style={{ marginRight: '10px', cursor: 'pointer' }}
                onClick={() => {
                  setTermsAndConditionsModal(true);
                }}
              >
                이용약관
              </span>
              <a target='_blank' rel='noopener noreferrer' href={CRefundInformation}>
                환불규정
              </a>
            </Col>
          </Row>
        )}
      </FooterWrapper>
      <PrivacyModal visible={privacyModal} setVisible={setPrivacyModal} />
      <TermsAndConditionsModal visible={termsAndConditionsModal} setVisible={setTermsAndConditionsModal} />
    </>
  );
};

export default FooterArea;
